module.exports = __webpack_public_path__ + "img/slashio-photography-iOuEGWPB22U-unsplash.4922e587.jpg";